import { types, getParent, flow } from 'mobx-state-tree'

import ParkingTicket from '~/stores/models/ParkingTicket'
import * as ParkingTicketService from '~/services/parking/ticket'
import Network from './Network'


const UserParkingTicketsBaseModel = types
  .model('UserParkingTicketsBaseModel', {
    list: types.array(ParkingTicket),
    parkingService: types.optional(Network, {})
  })
  .views(self => ({
    get sessionToken() {
      return getParent(self).auth.user.sessionToken
    }
  }))
  .actions(self => ({
    loadIfNecessary() {
      return self.fetchAll()
    },
    setTickets(tickets) {
      self.list = tickets
    },
    fetchAll: flow(function* fetch() {
      let success = false
      try {
        if (!self.sessionToken) return false // user is not signed in
        if (self.parkingService.isLoading) {
          return true
        }
        self.parkingService.requestStart()
        const tickets = yield ParkingTicketService.fetchAllParkingTickets(self.sessionToken)
        self.setTickets(tickets)
        success = true
        self.parkingService.requestComplete()
      } catch (error) {
        if (process.env.WINIT_ENV !== 'test') {
          console.error('error fetching all of a users parking tickets', error)
        }
        success = false
        self.parkingService.requestError(error)
      }
      return success
    })

  }))

export default UserParkingTicketsBaseModel
